import {
  LIST_MEDICAL_DOCUMENT_RESULT_REQUEST,
  LIST_MEDICAL_DOCUMENT_RESULT_SUCCESS,
  LIST_MEDICAL_DOCUMENT_RESULT_FAIL,
  PRINT_RESULT_MEDICAL_DOCUMENT_REQUEST,
  PRINT_RESULT_MEDICAL_DOCUMENT_SUCCESS,
  PRINT_RESULT_MEDICAL_DOCUMENT_FAIL,
  SEND_RESULT_MEDICAL_DOCUMENT_REQUEST,
  SEND_RESULT_MEDICAL_DOCUMENT_SUCCESS,
  SEND_RESULT_MEDICAL_DOCUMENT_FAIL,
  SEND_INTEGRATION_RESULT_MEDICAL_DOCUMENT_REQUEST,
  SEND_INTEGRATION_RESULT_MEDICAL_DOCUMENT_SUCCESS,
  SEND_INTEGRATION_RESULT_MEDICAL_DOCUMENT_FAIL,
  UPDATE_FORMAT_OPTION_RESULT_MEDICAL_DOCUMENT_REQUEST,
  UPDATE_FORMAT_OPTION_RESULT_MEDICAL_DOCUMENT_SUCCESS,
  UPDATE_FORMAT_OPTION_RESULT_MEDICAL_DOCUMENT_FAIL,
  HISTORY_LOG_RESULT_MEDICAL_DOCUMENT_REQUEST,
  HISTORY_LOG_RESULT_MEDICAL_DOCUMENT_SUCCESS,
  HISTORY_LOG_RESULT_MEDICAL_DOCUMENT_FAIL,
  EXPORT_RESULT_MEDICAL_DOCUMENT_REQUEST,
  EXPORT_RESULT_MEDICAL_DOCUMENT_SUCCESS,
  EXPORT_RESULT_MEDICAL_DOCUMENT_FAIL,
  LIST_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_REQUEST,
  LIST_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_SUCCESS,
  LIST_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_FAIL,
  DETAIL_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_REQUEST,
  DETAIL_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_SUCCESS,
  DETAIL_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_FAIL,
  DETAIL_LIST_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_REQUEST,
  DETAIL_LIST_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_SUCCESS,
  DETAIL_LIST_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_FAIL,
  VERIFY_INSPECTION_RESULT_REQUEST,
  VERIFY_INSPECTION_RESULT_SUCCESS,
  VERIFY_INSPECTION_RESULT_FAIL,
  DOWNLOAD_RESULT_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_REQUEST,
  DOWNLOAD_RESULT_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_SUCCESS,
  DOWNLOAD_RESULT_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_FAIL,
  LIST_MEDICAL_DOCUMENT_RESULT_ITEM_REQUEST,
  LIST_MEDICAL_DOCUMENT_RESULT_ITEM_SUCCESS,
  LIST_MEDICAL_DOCUMENT_RESULT_ITEM_FAIL,
  RESET_LIST_MEDICAL_DOCUMENT_RESULT_ITEM,
  LIST_BULK_GENERATE_MEDICAL_DOCUMENT_LINKS_REQUEST,
  LIST_BULK_GENERATE_MEDICAL_DOCUMENT_LINKS_SUCCESS,
  LIST_BULK_GENERATE_MEDICAL_DOCUMENT_LINKS_FAIL,
  GET_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_SUMMARY_REQUEST,
  GET_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_SUMMARY_SUCCESS,
  GET_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_SUMMARY_FAIL,
  GET_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_DETAILS_REQUEST,
  GET_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_DETAILS_SUCCESS,
  GET_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_DETAILS_FAIL,
  EXPORT_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_REQUEST,
  EXPORT_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_SUCCESS,
  EXPORT_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_FAIL
} from '../../constants/medical-documents'

const initialState = {
  loading: false,
  loadingDetail: false,
  loadingSendIntegration: false,
  loadingUpdateFormatOption: false,
  results: [],
  downloadResults: [],
  detailDownloadResult: {},
  detailDownloadResults: [],
  error: '',
  resultItems: [],
  pageable: {
    page: 1,
    size: 10
  },
  loadingBulkGenerateLinks: false,
  bulkGenerateLinksResults: [],
  pageableBulkGenerateLinks: {
    page: 1,
    size: 10
  },
  loadingDetailBulkGenerateLinks: false,
  detailBulkGenerateLinks: [],
  pageableDetailBulkGenerateLinks: {
    page: 1,
    size: 10
  },
  summaryBulkGenerateLinks: {},
  loadingExportBulkGenerateLinks: false
}

const medicalDocumentReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MEDICAL_DOCUMENT_RESULT_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_MEDICAL_DOCUMENT_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.payload,
        pageable: action.pageable,
        error: ''
      }
    case LIST_MEDICAL_DOCUMENT_RESULT_FAIL:
      return {
        ...state,
        loading: false,
        results: action?.dummy,
        error: action.payload
      }
    case PRINT_RESULT_MEDICAL_DOCUMENT_REQUEST:
      return {
        ...state,
        loadingPrint: true
      }
    case PRINT_RESULT_MEDICAL_DOCUMENT_SUCCESS:
      return {
        ...state,
        loadingPrint: false,
        print: action.payload,
        error: ''
      }
    case PRINT_RESULT_MEDICAL_DOCUMENT_FAIL:
      return {
        ...state,
        loadingPrint: false,
        print: action?.dummy,
        error: action.payload
      }
    case SEND_RESULT_MEDICAL_DOCUMENT_REQUEST:
      return {
        ...state,
        loadingSend: true
      }
    case SEND_RESULT_MEDICAL_DOCUMENT_SUCCESS:
      return {
        ...state,
        loadingSend: false,
        send: action.payload,
        error: ''
      }
    case SEND_RESULT_MEDICAL_DOCUMENT_FAIL:
      return {
        ...state,
        loadingSend: false,
        send: action?.dummy,
        error: action.payload
      }
    case SEND_INTEGRATION_RESULT_MEDICAL_DOCUMENT_REQUEST:
      return {
        ...state,
        loadingSendIntegration: true,
        error: ''
      }
    case SEND_INTEGRATION_RESULT_MEDICAL_DOCUMENT_SUCCESS:
      return {
        ...state,
        loadingSendIntegration: false,
        error: ''
      }
    case SEND_INTEGRATION_RESULT_MEDICAL_DOCUMENT_FAIL:
      return {
        ...state,
        loadingSendIntegration: false,
        error: action.payload
      }
    case UPDATE_FORMAT_OPTION_RESULT_MEDICAL_DOCUMENT_REQUEST:
      return {
        ...state,
        loadingUpdateFormatOption: true
      }
    case UPDATE_FORMAT_OPTION_RESULT_MEDICAL_DOCUMENT_SUCCESS:
      return {
        ...state,
        loadingUpdateFormatOption: false,
        updateFormatOption: action.payload,
        error: ''
      }
    case UPDATE_FORMAT_OPTION_RESULT_MEDICAL_DOCUMENT_FAIL:
      return {
        ...state,
        loadingUpdateFormatOption: false,
        updateFormatOption: action?.dummy,
        error: action.payload
      }
    case HISTORY_LOG_RESULT_MEDICAL_DOCUMENT_REQUEST:
      return {
        ...state,
        loadingHistory: true
      }
    case HISTORY_LOG_RESULT_MEDICAL_DOCUMENT_SUCCESS:
      return {
        ...state,
        loadingHistory: false,
        history: action.payload,
        error: ''
      }
    case HISTORY_LOG_RESULT_MEDICAL_DOCUMENT_FAIL:
      return {
        ...state,
        loadingHistory: false,
        history: action?.dummy,
        error: action.payload
      }
    case EXPORT_RESULT_MEDICAL_DOCUMENT_REQUEST:
      return {
        ...state,
        loadingExport: true
      }
    case EXPORT_RESULT_MEDICAL_DOCUMENT_SUCCESS:
      return {
        ...state,
        loadingExport: false,
        export: action.payload,
        error: ''
      }
    case EXPORT_RESULT_MEDICAL_DOCUMENT_FAIL:
      return {
        ...state,
        loadingExport: false,
        export: action?.dummy,
        error: action.payload
      }
    case LIST_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        downloadResults: action.payload,
        pageableDownloadResults: action.pageable,
        error: ''
      }
    case LIST_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_FAIL:
      return {
        ...state,
        loading: false,
        downloadResults: action?.dummy,
        error: action.payload
      }
    case DETAIL_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        detailDownloadResult: action.payload,
        error: ''
      }
    case DETAIL_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_FAIL:
      return {
        ...state,
        loadingDetail: false,
        detailDownloadResult: action?.dummy,
        error: action.payload
      }
    case DETAIL_LIST_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_REQUEST:
      return {
        ...state,
        loading: true
      }
    case DETAIL_LIST_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        detailDownloadResults: action.payload,
        pageable: action.pageable,
        error: ''
      }
    case DETAIL_LIST_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_FAIL:
      return {
        ...state,
        loading: false,
        detailDownloadResults: action?.dummy,
        error: action.payload
      }
    case VERIFY_INSPECTION_RESULT_REQUEST:
      return {
        ...state,
        loading: true
      }
    case VERIFY_INSPECTION_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: ''
      }
    case VERIFY_INSPECTION_RESULT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case DOWNLOAD_RESULT_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_REQUEST:
      return {
        ...state,
        loadingDownload: true
      }
    case DOWNLOAD_RESULT_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_SUCCESS:
      return {
        ...state,
        loadingDownload: false,
        downloadUrl: action.payload,
        error: ''
      }
    case DOWNLOAD_RESULT_MEDICAL_DOCUMENT_DOWNLOAD_RESULT_FAIL:
      return {
        ...state,
        loadingDownload: false,
        downloadUrl: action?.dummy,
        error: action.payload
      }
    case LIST_MEDICAL_DOCUMENT_RESULT_ITEM_REQUEST:
      return {
        ...state,
        loadingResultItems: true
      }
    case LIST_MEDICAL_DOCUMENT_RESULT_ITEM_SUCCESS:
      return {
        ...state,
        loadingResultItems: false,
        resultItems: action.payload,
        error: ''
      }
    case LIST_MEDICAL_DOCUMENT_RESULT_ITEM_FAIL:
      return {
        ...state,
        loadingResultItems: false,
        error: action.payload
      }
    case RESET_LIST_MEDICAL_DOCUMENT_RESULT_ITEM:
      return {
        ...state,
        resultItems: []
      }
    case LIST_BULK_GENERATE_MEDICAL_DOCUMENT_LINKS_REQUEST:
      return {
        ...state,
        loadingBulkGenerateLinks: true
      }
    case LIST_BULK_GENERATE_MEDICAL_DOCUMENT_LINKS_SUCCESS:
      return {
        ...state,
        loadingBulkGenerateLinks: false,
        bulkGenerateLinksResults: action.payload,
        pageableBulkGenerateLinks: action.pageable,
        error: ''
      }
    case LIST_BULK_GENERATE_MEDICAL_DOCUMENT_LINKS_FAIL:
      return {
        ...state,
        loadingBulkGenerateLinks: false,
        bulkGenerateLinksResults: action?.dummy,
        error: action.payload
      }
    case GET_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_SUMMARY_REQUEST:
      return {
        ...state,
        loadingDetailBulkGenerateLinks: true
      }
    case GET_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingDetailBulkGenerateLinks: false,
        summaryBulkGenerateLinks: action.payload,
        error: ''
      }
    case GET_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_SUMMARY_FAIL:
      return {
        ...state,
        loadingDetailBulkGenerateLinks: false,
        summaryBulkGenerateLinks: {},
        error: action.payload
      }
    case GET_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_DETAILS_REQUEST:
      return {
        ...state,
        loadingDetailBulkGenerateLinks: true
      }
    case GET_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_DETAILS_SUCCESS:
      return {
        ...state,
        loadingDetailBulkGenerateLinks: false,
        detailBulkGenerateLinks: action.payload,
        pageableDetailBulkGenerateLinks: action.pageable,
        error: ''
      }
    case GET_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_DETAILS_FAIL:
      return {
        ...state,
        loadingDetailBulkGenerateLinks: false,
        detailBulkGenerateLinks: action?.dummy,
        error: action.payload
      }
    case EXPORT_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_REQUEST:
      return {
        ...state,
        loadingExportBulkGenerateLinks: true
      }
    case EXPORT_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_SUCCESS:
      return {
        ...state,
        loadingExportBulkGenerateLinks: false,
        error: ''
      }
    case EXPORT_BULK_GENERATE_MEDICAL_DOCUMENT_LINK_FAIL:
      return {
        ...state,
        loadingExportBulkGenerateLinks: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default medicalDocumentReducer
